// extracted by mini-css-extract-plugin
var _1 = "styles-module__background___PnMPp";
var _2 = "styles-module__darker___QGr6R";
var _3 = "styles-module__image___GvTjP";
export { _1 as "background", _2 as "darker", _3 as "image" }
